import styled from "styled-components";

export const CampaignCreatePreviewsWrapper = styled.div`
  margin-top: 20px;
  text-align: center;
`;

export const ErrorMessage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  text-align: center;
  padding: 20px;

  h2 {
    color: #e74c3c;
    margin-bottom: 10px;
  }

  p {
    color: #666;
    max-width: 500px;
    line-height: 1.5;
  }
`;
